import { useEffect } from 'react'
import { Label } from '@/common/ui/label'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { UseFormReturn } from 'react-hook-form'
import useQueryGetSMSProviders from '../../api/hooks/useQueryGetSMSProviders'
import useQueryGetSMSProviderSenders from '../../api/hooks/useQueryGetSMSProviderSenders'

interface SMSSettingsFormProps {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	form: UseFormReturn<any>
}

export const SMSSettingsForm = ({ form }: SMSSettingsFormProps) => {
	const { data: providersData, isLoading: isLoadingProviders } =
		useQueryGetSMSProviders()

	// Automatically use the first provider's ID
	const providerId = providersData?.[0]?.id || ''

	const { data: sendersData, isLoading: isLoadingSenders } =
		useQueryGetSMSProviderSenders(providerId, {
			enabled: !!providerId,
		})

	useEffect(() => {
		// Automatically set the provider ID when providers are loaded
		if (providerId && !form.getValues('providerId')) {
			form.setValue('providerId', providerId)
		}
	}, [providerId, form])

	return (
		<div className="space-y-4 rounded-lg border p-4">
			<div>
				<Label className="text-base">ตั้งค่า SMS</Label>
				<p className="text-sm text-muted-foreground">เลือกชื่อผู้ส่ง SMS</p>
			</div>

			<FormField
				control={form.control}
				name="senderId"
				render={({ field }) => (
					<FormItem>
						<FormLabel>ชื่อผู้ส่ง</FormLabel>
						<FormControl>
							<Select
								onValueChange={field.onChange}
								value={field.value}
								disabled={isLoadingProviders || isLoadingSenders || !providerId}
							>
								<SelectTrigger>
									<SelectValue placeholder="เลือกชื่อผู้ส่ง" />
								</SelectTrigger>
								<SelectContent>
									{sendersData?.map((sender) => (
										<SelectItem key={sender.id} value={sender.senderId}>
											{sender.senderName}
										</SelectItem>
									))}
								</SelectContent>
							</Select>
						</FormControl>
						<FormDescription>ชื่อผู้ส่งที่จะแสดงใน SMS</FormDescription>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	)
}
